export default __webpack_public_path__ + "static/media/mx_ine_ife_front.8eb8fa27.jpeg";